import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-hover-dialog',
  template: `<div class="tooltip-box">{{ data.title }}</div>`,
  styles: [
    `
      .tooltip-box {
        font-family: 'SegoeUI', 'KhmerOSBattambang' !important;
        background: white !important;
        color: #2a5298 !important;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.082);
        border: 0.13rem solid #2a5298a4;
        letter-spacing: 0.03rem;
        padding: 0 8px !important;
        border-radius: 13px !important;
        min-width: 80px;
        line-height: 1.5rem;
        margin: 6px !important;
        font-size: 13px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    `,
  ],
})
export class ToolTipMenuComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { title: string }) {}
}
